<template>
  <div>
    <!-- 頭部 -->
    <headers :nav-index="1"></headers>
    <div class="p-Top-58">
      <!-- 資訊分類 -->
      <news-sort :select-cate="article.cate_id" v-if="article.cate_id!=0"></news-sort>
      <!-- 麵包屑 -->
      <div class="crumbs-wrap" v-if="article.id">
        <div class="crumbs-box">
          <a-breadcrumb>
            <a-breadcrumb-item>{{$t('moduleTitles.home')}}</a-breadcrumb-item>
            <a-breadcrumb-item v-if="article.cate_id!=0">
              <a @click="goCate(article.cate_id)">{{article.cate_name}}</a>
            </a-breadcrumb-item>
            <a-breadcrumb-item>{{article.title}}</a-breadcrumb-item>
          </a-breadcrumb>
        </div>
      </div>
      <!-- 詳情部分 -->
      <div class="details-wrap">
        <div class="details-box">
          <div class="details-con">
            <div class="titles">{{article.title}}</div>
            <div class="contents ql-editor" v-html="article.content"></div>
            <div class="datas">
              <span>{{article.create_time}}</span>
              <span>{{$t('descriptions.views')}}：{{article.visits}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <footers></footers>
  </div>
</template>

<script>
import headers from "./components/header";
import footers from "./components/footer";
import newsSort from "./components/newsSort";
import { articleDetail,addArticleVisits } from "@/api/index";

export default {
  name: "newsDetails",
  components: {
    headers,
    footers,
    newsSort,
  },
  data() {
    return {
      article: {},
    };
  },
  watch: {
    $route: {
      handler() {
        let id = ~~this.$route.params.id;
        this.articleDetail(id);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  methods: {
    articleDetail(id) {
      //獲取詳情信息
      articleDetail({ id: id }).then((res) => {
        this.article = res.data;
      });

      //增加閱讀量
      addArticleVisits({id:id});
    },
    goCate(cate) {
      this.$router.push({ path: `/news/${cate}` });
    },
  },
};
</script>

<style lang="less" scoped>
.crumbs-wrap {
  background-color: #f8f8f8;
  .crumbs-box {
    max-width: 1360px;
    padding: 20px 10px;
    margin: 0 auto;
  }
}
.details-wrap {
  background-color: #f8f8f8;
  padding-bottom: 40px;
  .details-box {
    max-width: 1360px;
    padding: 0 10px;
    margin: 0 auto;
    .details-con {
      border: 1px solid #efefef;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.03);
      background-color: #ffffff;
      padding: 30px 180px;
      box-sizing: border-box;
      .titles {
        font-size: 20px;
        color: #333;
        padding-bottom: 20px;
        margin-bottom: 20px;
        border-bottom: 1px solid #e1e1e1;
      }
      .contents {
        min-height: 500px;
      }
      .datas {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        border-top: 1px solid #e1e1e1;
        font-size: 12px;
        color: #aaaaaa;
        margin-top: 20px;
      }
    }
  }
}
@media (max-width: 767px) {
  .crumbs-wrap {
    display: none;
  }
  .details-wrap {
    padding: 15px 0 30px 0;
    .details-box {
      padding: 0 15px;
      .details-con {
        padding: 30px;
        .titles {
          font-size: 16px;
          padding-bottom: 10px;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
